(() => {
  'use strict';
  const root = document.querySelector('.cr-inner-site');
  if (!root) return;
  const main = root.querySelector('main');
  if (!main) return;
  const title = main.querySelector('h1');
  const breadcrumb = document.createElement('nav');
  breadcrumb.className = 'ix-breadcrumb';
  breadcrumb.setAttribute('aria-label', 'Breadcrumb');
  const home = document.createElement('a'); home.href = '/'; home.textContent = 'Home';
  const divider = document.createElement('span'); divider.textContent = '/'; divider.setAttribute('aria-hidden', 'true');
  const current = document.createElement('span'); current.textContent = document.title.split('|')[0].trim();
  current.setAttribute('aria-current','page');
  breadcrumb.append(home, divider, current);
  if (!main.querySelector('[aria-label="Breadcrumb"]')) main.prepend(breadcrumb);
  // Keep the purpose-built guide and article navigation; generate contents only where missing.
  if (!main.querySelector('.article-layout aside,[data-editorial-toc]') && !['our-consultants','awards','testimonials','testimonials_'].includes(root.dataset.pageHandle)) {
    const headings = [...main.querySelectorAll('h2')].filter(h => !h.closest('.ix-card,.ix-related,.coverage-person,.cr-product-card,.info-card,.service-card,.review-card,.provider-trust-list,details') && h.textContent.trim());
    if (headings.length > 1) {
      const contents = document.createElement('details'); contents.className = 'ix-on-page';
      const summary = document.createElement('summary'); summary.textContent = 'Explore this page';
      const nav = document.createElement('nav'); nav.setAttribute('aria-label','On this page');
      headings.slice(0,16).forEach((h,i) => {
        if (!h.id) { let id = 'page-section-' + (i+1); while(document.getElementById(id)) id += '-a'; h.id=id; }
        const a = document.createElement('a'); a.href='#'+h.id; a.textContent=h.innerText.replace(/\s+/g,' ').trim(); nav.append(a);
      });
      contents.append(summary,nav);
      const hero = main.querySelector('.ix-hero,.coverage-intro,.new-intro,.page-intro,.cr-native>.wrap');
      if (hero) hero.after(contents); else breadcrumb.after(contents);
    }
  }
})();
